export interface IVideoModel extends Components.Schemas.VideoDto {}
export interface IVideoUploadModel extends Components.Schemas.VideoUploadDto {}

export const maxVideoTitleLength = 37;
export const maxVideoDescriptionLength = 140;
